import "./EventServices.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TrendRadarHero from "./sections/TrendRadarHero";
import CuratedMasterpieces from "./sections/CuratedMasterpieces";
import ApplyForProfessionalAccount from "./sections/ApplyForProfessionalAccount";
import Footer from "@/reusable_sections/Footer";
export default function EventServicesPage() {
  return <div>
      <MainNavigation />
      <TrendRadarHero />
      <CuratedMasterpieces />
      <ApplyForProfessionalAccount />
      <Footer />
    </div>;
}